import _ from 'lodash';
import workloadCore from './core';
import workloadLayout from './layout';
import workloadRenderer from './core/render';
import constants from '$$helpers/constants';

export default {
  init(instance) {
    const debouncedCalculateAndRender = _.debounce(needResize => {
      workloadCore.calculateAndRender(needResize);
    }, 250);

    instance.$ui.getView('workloadGrid').attachEvent('onBeforeColumnDragStart', () => workloadCore.isWorkloadPanelType());

    instance.attachEvent('onGridResizeEnd', () => {
      workloadLayout.renderZoomHourLayout();
    });
    instance.attachEvent('workloadRecalculate', () => {
      workloadCore.calculateAndRender();
    });
    instance.attachEvent('workloadClearCache', clearCacheData => {
      workloadCore.clearCache(clearCacheData);
    });
    instance.attachEvent('workloadClearAndParse', updatedData => {
      workloadCore.clearCache(updatedData);
      debouncedCalculateAndRender(false);
    });
    instance.attachEvent('change:work:time', () => {
      workloadCore.clearCache();
      workloadCore.calculateAndRender();
    });
    instance.attachEvent('onClickWorkloadTaskBar', resourceRowId => {
      workloadCore.clearCachedWorkerDataById(resourceRowId);
      workloadCore.calculateAndRender();
    });
    instance.attachEvent('onClickWorkloadMoreButton', () => {
      workloadCore.clearCachedWorkerDataById('unassigned-tasks');
      workloadCore.calculateAndRender();
    });
    instance.attachEvent('onDropWorkloadTaskBar', resourceRowId => {
      workloadCore.clearCachedWorkerDataById(resourceRowId);
    });
    instance.attachEvent('onGanttRender', () => {
      if (workloadCore.checkIsUpdatedTimeline()) {
        debouncedCalculateAndRender(false);
      }
      workloadCore.config.taskCellsEditMode = {};
    });
    instance.attachEvent('onChangeWorkloadCalculationMode', value => {
      workloadCore.changeCalculationMode(value);
    });
    instance.attachEvent('closeWorkloadResourceRows', () => {
      workloadCore.config.openedResources = {};
    });
    instance.attachEvent('onClickWorkloadResourceRow', rowId => {
      
    });
    instance.attachEvent('onChangeWorkloadViewMode', mode => {
      workloadCore.changeViewMode(mode);
    });
    instance.event(instance.$ui.getView('workloadTimeline').$task, 'scroll', _.debounce(e => {
      workloadRenderer.onAfterScrollTimeline(e);
      workloadCore.refresh();
    }, 50));
    this.initForBlockedWorkload(instance);
  },
  initForBlockedWorkload(instance) {
    instance.attachEvent('export:onConfigOptionChange', option => {
      if (option.id === 'hide_workload') {
        const workloadActivity = instance.ganttDataApi.getUserActivitySettings(constants.USER_ACTIVITIES.WORKLOAD);
        const id = instance.config.gantt_id || instance.config.multiview_id;
        let workloadHeight = constants.WORKLOAD_PANEL_DEFAULT_HEIGHT;

        if (workloadActivity?.workloadHeight) {
          workloadHeight = workloadActivity.workloadHeight[id];
        }
        workloadLayout.togglePanelAndRender(option.value, workloadHeight);
      }
    });
  },
};
